import React from 'react';
import classNames from 'classnames/bind';
import { PageFixer } from '@beef/smart-kit';
import { shallowEqual, useSelector } from 'react-redux';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { ThreeFoursModal } from 'widgets/ThreeFours';
import {
  getSharedZoneContentSettings,
  getSharedZonePageHasNavigation,
  getSharedZonePageHasTradeInBanner,
} from 'store/SharedZone/selectors';
import { getThreeFoursAvailability } from 'store/widgets/ThreeFours/selectors';

import PageLayout from '../../_PageLayout';
import style from './SharedZoneNew.module.pcss';
import { SharedZoneNewTitle } from './SharedZoneNewTitle';
import { SharedZoneNewSubtitle } from './SharedZoneNewSubtitle';
import { SharedZoneNewOffers } from './SharedZoneNewOffers';
import { SharedZoneNewServices } from './SharedZoneNewServices';
import SharedZoneNewQuestions from './SharedZoneNewQuestions';

const cx = classNames.bind(style);

const SharedZoneNew = () => {
  const { hasNavigation, hasTradeInBanner, hasThreeFours, contentSettings, isMobile } = useSelector(
    (state) => ({
      hasNavigation: getSharedZonePageHasNavigation(state),
      hasTradeInBanner: getSharedZonePageHasTradeInBanner(state),
      hasThreeFours: getThreeFoursAvailability(state),
      contentSettings: getSharedZoneContentSettings(state),
      isMobile: isScreenBelow640(state),
    }),
    shallowEqual,
  );

  const {
    settings: { mainTitle, subtitle, blockServices, blockCalculate, blockFaq },
    damProdam,
    url,
  } = contentSettings;

  const { blockServicesTitle, services } = blockServices;

  return (
    <PageLayout
      withNavigation={hasNavigation}
      withTradeIn={hasTradeInBanner}
      beforeContent={hasThreeFours && <ThreeFoursModal />}
    >
      <PageFixer>
        <div className={cx('wrap')}>
          {mainTitle && <SharedZoneNewTitle title={mainTitle} />}
          {subtitle && <SharedZoneNewSubtitle subtitle={subtitle} />}
          <SharedZoneNewOffers title={blockServicesTitle} services={services} />
          <SharedZoneNewServices
            calculateSettings={blockCalculate}
            damProdamSettings={damProdam}
            frameUrl={url}
            isMobile={isMobile}
          />
          <SharedZoneNewQuestions faq={blockFaq} />
        </div>
      </PageFixer>
    </PageLayout>
  );
};

export { SharedZoneNew };
